import { render } from "./SupabaseTest.vue?vue&type=template&id=b639eaf6&ts=true"
import script from "./SupabaseTest.vue?vue&type=script&lang=ts"
export * from "./SupabaseTest.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__